export const themeImageAriaLabel1 = "szl$Bc";
export const themeImageAriaLabel2 = "tzl$Bc";
export const themeImageAriaLabel3 = "uzl$Bc";
export const themeImageAriaLabel4 = "vzl$Bc";
export const themeImageAriaLabel5 = "wzl$Bc";
export const themeImageAriaLabel6 = "xzl$Bc";
export const themeImageAriaLabel7 = "yzl$Bc";
export const themeImageAriaLabel8 = "zzl$Bc";
export const themeImageAriaLabel9 = "Azl$Bc";
export const themeImageAriaLabel10 = "wZzT6c";
export default {themeImageAriaLabel1,themeImageAriaLabel2,themeImageAriaLabel3,themeImageAriaLabel4,themeImageAriaLabel5,themeImageAriaLabel6,themeImageAriaLabel7,themeImageAriaLabel8,themeImageAriaLabel9,themeImageAriaLabel10};